import React, { createContext, useCallback, useContext, useState } from 'react';
import { AlertTriangle, CheckCircle2, Info } from 'lucide-react';

const AlertContext = createContext({
  showAlert: () => {},
});

export function useAlert() {
  return useContext(AlertContext);
}

const ICONS = {
  error: AlertTriangle,
  warning: AlertTriangle,
  success: CheckCircle2,
  info: Info,
};

const ICON_COLOR = {
  error: 'var(--red)',
  warning: '#d97706',
  success: 'var(--green)',
  info: 'var(--accent)',
};

export function AlertProvider({ children }) {
  const [alert, setAlert] = useState(null);

  const showAlert = useCallback((opts) => {
    if (!opts) return;
    if (typeof opts === 'string') {
      setAlert({ type: 'error', title: 'Notice', message: opts });
      return;
    }
    setAlert({
      type: opts.type || 'error',
      title: opts.title || (opts.type === 'success' ? 'Success' : 'Notice'),
      message: opts.message || '',
    });
  }, []);

  const close = useCallback(() => setAlert(null), []);

  const type = alert?.type || 'error';
  const Icon = ICONS[type] || AlertTriangle;

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {alert && (
        <div className="modal-backdrop" onClick={close} role="presentation">
          <div className="modal" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true">
            <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
              <Icon size={22} color={ICON_COLOR[type]} strokeWidth={2} style={{ flexShrink: 0, marginTop: 2 }} />
              <div>
                <h3 style={{ marginBottom: 8 }}>{alert.title}</h3>
                <p className="modal-sub" style={{ marginBottom: 0, whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
                  {alert.message}
                </p>
              </div>
            </div>
            <div className="modal-actions">
              <button type="button" className="btn btn-primary" onClick={close}>OK</button>
            </div>
          </div>
        </div>
      )}
    </AlertContext.Provider>
  );
}
